import React from 'react';
import ProjectCard from './ProjectCard';
import { projects } from '../data/projects';
import { useLanguage } from '../i18n/LanguageContext';
import { useInView } from '../hooks/useInView';
import '../styles/components/Projects.css';

function Projects() {
  const { t } = useLanguage();
  const [headingRef, headingInView] = useInView();
  const [contentRef, contentInView] = useInView();

  return (
    <section className="projects" id="projects">
      <div className="container">
        <h2 ref={headingRef} className={`reveal ${headingInView ? 'in-view' : ''}`}>{t.projects.title}</h2>
        <div ref={contentRef} className={`projects-grid reveal reveal-delay ${contentInView ? 'in-view' : ''}`}>
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
